export function formatNumber (x, toFixed = 0) {
    if (!x && x != 0) {
        return x
    }
    if (toFixed === 0) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    } else if (toFixed === 2) {
        return x.toLocaleString(undefined,
            {'minimumFractionDigits':2,'maximumFractionDigits':2});
    }
}

export function dataIsCorrect (x) {
    return x !== null && x !== undefined && x !== ''
}

export function phoneNumberIsCorrect (x) {
    return x !== null && x !== undefined && x !== '' && x.length >= 10 && x.length <= 15
}
